// frontend/src/components/cardOnFile/lastDayBandPresence.js
//
// "Is the trial's last-day band on screen?" - a tiny external store, because
// the band (painted by `SubscriptionBanner` on the dashboard) and the navbar's
// upgrade pill live in different subtrees.
//
// ONE UPGRADE BUTTON PER SCREEN (fix round 2). On the last day the band
// carries its own "שדרג" button; the navbar pill beside it made two upgrade
// buttons on a desktop screen. While the band is mounted the navbar stands its
// BAR pill down (the menu row stays - it is not on screen together with the
// band's button). Everywhere else - other pages, no band, or the band mounted
// but hidden (the dashboard's archive view, `concealed`) - the pill is
// unchanged.
//
// Counted rather than a boolean, so a remount (StrictMode, a route change
// that re-renders both the old and the new tree for a commit) never leaves a
// stale "shown".

import { useEffect, useSyncExternalStore } from "react";

let mounted = 0;
const listeners = new Set();

const notify = () => {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch {
      /* one bad subscriber must not starve the others */
    }
  });
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/**
 * The band calls this: it is on screen while the calling component is mounted
 * AND `enabled`. The dashboard's archive view keeps the band mounted but
 * hidden (`concealed`) - then it must not stand the navbar pill down, or the
 * screen would carry no upgrade button at all.
 *
 * @param {boolean} [enabled=true]
 */
export const useAnnounceLastDayBand = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return undefined;
    mounted += 1;
    notify();
    return () => {
      mounted = Math.max(0, mounted - 1);
      notify();
    };
  }, [enabled]);
};

/**
 * The navbar reads this.
 *
 * @returns {boolean} the last-day band is on screen
 */
export const useLastDayBandOnScreen = () =>
  useSyncExternalStore(
    subscribe,
    () => mounted > 0,
    () => false
  );
